<template>
  <div
    class="container"
    :class="{ 'has-refundinfo': refundInfo.refundNo}"
  >
    <van-cell-group>
      <van-cell
        :title="`活动编号：${activityId}`"
      />
      <van-cell
        :title="`活动生效日期：${getTime(startTime)}`"
      />
      <van-cell
        v-if="endTime"
        :title="`活动结束日期：${getTime(endTime)}`"
      />
      <van-cell
        v-if="isAgentSlottingFee"
        :title="`活动时长：${dayCount}天`"
      />
      <template v-if="!isAgentPrePay&&!isAgentConditionPay&&!isAgentSlottingFee">
        <van-cell
          v-for="(item,index) in contractUrls"
          :key="item"
          class="contract"
          @click="onClickContract(item)"
        >
          <template #title>
            活动合同：<span :class="{'contract-name':!$isWXApplet}">美团充电宝活动合作协议{{ index>0?`-${index}`:'' }}</span>
          </template>
          <template
            v-if="!$isWXApplet"
            #default
          >
            <text-arrow text="预览" />
          </template>
        </van-cell>
      </template>
      <van-cell
        v-if="terminateLetter"
        class="contract"
        @click="onClickContract(terminateLetter)"
      >
        <template #title>
          <span style="color:red">解约退款通知书：</span><span :class="{'contract-name':!$isWXApplet}">解除协议暨退款通知书</span>
        </template>
        <template
          v-if="!$isWXApplet"
          #default
        >
          <text-arrow text="预览" />
        </template>
      </van-cell>
      <van-cell
        :title="`参与活动门店：${poiCounts}个`"
      />
      <van-cell
        v-if="!isAgentPrePay"
        :title="`已收金额：${paidAmount}元`"
        @click="onClickPaid(activityId)"
      >
        <text-arrow
          v-if="!isAgentConditionPay&&!isAgentSlottingFee"
          text="查看"
        />
      </van-cell>
      <van-cell
        v-if="isAgentPrePay"
        :title="`约定每期金额：${stageAmount}元`"
      />
      <van-cell
        v-if="isConditionPay||isAgentConditionPay"
        :title="`目标GTV：${targetGtv}元`"
      />
      <van-cell
        v-if="isConditionPay||isAgentConditionPay"
        :title="`截止昨日完成GTV：${divideGtv}元`"
      />
      <van-cell
        v-if="isPrePay||isAgentPrePay"
        :title="`截止昨日已跑回分成：${divideAmount}元`"
      />
      <van-cell
        v-if="Number(merchantRefundedAmount)"
        :title="`已完成退款：${merchantRefundedAmount}元`"
      />
    </van-cell-group>
    <condition-pay-bill
      v-if="isConditionPay"
      :list="billList"
      @click-cell="onClickBillItem"
    />
    <div
      v-if="!$isWXApplet&&refundInfo.refundNo"
      class="merchant-refund__info"
    >
      <div class="merchant-refund__title">
        活动退款详情
      </div>
      <div>退款金额：{{ refundInfo.refundAmount | formatAmount }}元</div>
      <div>操作BD：{{ refundInfo.bdName }}</div>
      <mtd-button
        type="primary"
        style="margin: 10px auto"
        @click="submitPay"
      >
        确认支付
      </mtd-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ActivityApi from '@/api/activity';
import { ActivityTypeEnum, getActivityDesc, getActivityStatusDesc } from '@/constants/activity';
import STATUS from '@/constants/status';
import { formatTimestamp } from '@/util/filter';
import config from '@/config';
import TextArrow from '@/components/TextArrow';
import ConditionPayBill from './ConditionPayBill';

export default {
  name: 'ActivityDetail',
  components: {
    TextArrow,
    ConditionPayBill,
  },
  data() {
    const { activityId, activityType } = this.$route.query;
    return {
      activityId,
      activityType: Number(activityType),
      startTime: null,
      endTime: null,
      contractName: '',
      contractUrls: [],
      terminateLetter: '',
      poiCounts: 0,
      paidAmount: '',
      stageAmount: '',
      targetGtv: '',
      divideGtv: '',
      divideAmount: 0,
      merchantRefundedAmount: '',
      billList: [],
      refundInfo: {},
      dayCount: 0,
    };
  },
  computed: {
    ...mapState(['bizlogintoken']),
    ...mapState('billModule', ['customerId']),
    isConditionPay() {
      return this.activityType === ActivityTypeEnum.CONDITION_PAY;
    },
    isPrePay() {
      return this.activityType === ActivityTypeEnum.PRE_PAY || this.activityType === ActivityTypeEnum.CIRCLE_PRE_PAY;
    },
    isAgentPrePay() {
      return this.activityType === ActivityTypeEnum.AGENT_PRE_PAY;
    },
    isAgentSlottingFee() {
      return this.activityType === ActivityTypeEnum.AGENT_SLOTTING_FEE;
    },
    isAgentConditionPay() {
      return this.activityType === ActivityTypeEnum.AGENT_CONDITION_PAY;
    },
  },
  async created() {
    this.$dialog.loading.show();
    const { activityId, coustomerId } = this;
    await Promise.all([
      this.getActivityDetail(activityId),
      this.getMonthDivideGtvList(coustomerId, activityId),
      this.getRefundInfo(activityId),
    ]);
    this.$dialog.loading.hide();
  },
  methods: {
    async getActivityDetail(activityId) {
      try {
        const { code, data } = await ActivityApi.getActivityDetail(activityId);
        if (code === STATUS.SUCCESS) {
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.contractUrls = (data.contractUrl || '').split(';');
          this.contractName = data.contractName;
          this.terminateLetter = data.terminateLetter;
          this.poiCounts = data.poiCounts;
          this.paidAmount = data.paidAmount;
          this.stageAmount = data.stageAmount;
          this.targetGtv = data.targetGtv;
          this.divideGtv = data.divideGtv;
          this.divideAmount = data.divideAmount;
          this.merchantRefundedAmount = data.merchantRefundedAmount;
          this.dayCount = data.dayCount;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getMonthDivideGtvList(customerId, activityId) {
      if (this.isConditionPay || this.isAgentConditionPay) {
        try {
          const { code, data } = await ActivityApi.getActivityMonthGTVList(customerId, activityId);
          if (code === STATUS.SUCCESS) {
            this.billList = data || [];
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    async getRefundInfo(activityId) {
      try {
        const { code, data } = await ActivityApi.getRefundInfo(activityId);
        if (code === STATUS.SUCCESS) {
          this.refundInfo = data || {};
        }
      } catch (e) {
        console.error(e);
      }
    },
    async submitPay() {
      // 如果没有下单，开店宝先下单。
      if (!this.refundInfo.tradeNo) {
        const params = {
          agreementId: this.activityId,
          refundType: 1,
          amount: this.refundInfo.refundAmount,
          refundNo: this.refundInfo.refundNo,
        };
        try {
          const { code, data } = await ActivityApi.submitRefundOrder(params);
          if (code === STATUS.SUCCESS) {
            this.refundInfo.tradeNo = data.tradeNo;
            this.refundInfo.payToken = data.payToken;
          } else {
            // 下单出错
            return;
          }
        } catch (e) {
          console.log(e);
          return;
        }
      }
      /**
       * 由于地址中可能会存在token等长的参数，所以自己拼一次
       */
      const { protocol, host, pathname } = window.location;
      const currentUrl = `${protocol}//${host}/${pathname}?activityId=${this.activityId}&activityType=${this.activityType}`;
      const envMap = {
        production: 'prod',
        staging: 'staging',
        test: 'test',
      };
      this.callPay(envMap, currentUrl);
    },
    callPay(envMap, currentUrl) {
      const JSSDKScript = document.createElement('script');
      const url = 'https://s3plus.meituan.net/static-prod01/com.sankuai.fspb.pay.sdk-files/pay-cashier-sdk-old.js';
      JSSDKScript.src = url;
      JSSDKScript.onload = () => {
        window.openCashier({
          // 环境参数和登录信息
          env: envMap[config.env] || 'test', // dev, test, staging, prod
          biz_token: this.bizlogintoken,
          login_type: '1',

          // 正常回调和异常回调地址
          pay_success_url: `${currentUrl}&refundPay=success`,
          redr_url: `${currentUrl}&refundPay=error`,

          // 订单信息和支付token
          tradeno: this.refundInfo.tradeNo,
          pay_token: this.refundInfo.payToken,

          // 其他参数
          nb_platform: 'touch',
          nb_source: 'i_biz_cashier',
          nb_app: 'bizmeituan',
          nb_show_nav: 0,
        });
      };
      document.body.appendChild(JSSDKScript);
    },
    getActivityDesc,
    getActivityStatusDesc,
    onClickContract(pdfUrl) {
      if (!this.$isWXApplet) {
        this.$router.push({ name: 'contractPdf', params: { pdfUrl } });
      }
    },
    onClickPaid(activityId) {
      const { isAgentConditionPay, isAgentPrePay, isAgentSlottingFee } = this;
      if (isAgentPrePay || isAgentSlottingFee || isAgentConditionPay) return;
      this.$router.push({
        name: 'ActivityPaidFlow',
        query: {
          activityId,
          customerId: this.customerId,
        },
      });
    },
    onClickBillItem(billMonth) {
      const { customerId, activityId } = this;
      this.$router.push({
        name: 'ActivityMonthBillDetail',
        query: {
          customerId,
          activityId,
          billMonth,
        },
      });
    },
    getTime(timestamp) {
      if (timestamp === null) {
        return '-';
      }
      return formatTimestamp(timestamp, 'yyyy-MM-dd');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
}
.contract {
  .contract-name {
    color: blue;
    text-decoration: underline;
  }
  .van-cell__value {
    flex: auto 0 0;
  }
}
.has-refundinfo{
  padding-bottom: 300px;
}
.merchant-refund__info{
  width: 100%;
  text-align: center;
  padding: 10px 20px;
  position: fixed;
  bottom: 0;
  background: #fff;
  box-shadow: 0px 0px 6px 1px #ccc;
  line-height: 1.8;
}
.merchant-refund__title{
  font-size: 28px;
  font-weight: bold;
  line-height: 2.5;
}
</style>
